import React, { useEffect, useState } from "react";
import styles from "./HeroSection.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import HomeServices from "../../../../pages/home/homeService/HomeService";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import { getCardImage } from "../../../../helper/getImageWithTranslations";

const HeroSection: React.FC = () => {
  const [cardData, setCardData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const selectedLanguage = useSelector(
    (state: RootState) => state.language.selectedLanguage?.code
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await HomeServices.CampaignData();

        if (res.status && Array.isArray(res.data)) {
          const now = new Date();

          const activeCampaigns = res.data.filter((campaign: any) => {
            if (!campaign.end_date) return true;

            const parts = campaign.end_date.split(".");

            const endDate = new Date(
              parseInt(parts[2], 10),
              parseInt(parts[1], 10) - 1,
              parseInt(parts[0], 10)
            );

            console.log(endDate);
            return endDate >= now;
          });

          setCardData(activeCampaigns);
        }
      } catch (error) {
        console.error(error, " data error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, selectedLanguage]);

  if (loading) {
    return (
      <section id={styles.hero_section}>
        <div className="container">
          <Swiper
            className={styles.heroSwiper}
            rewind={true}
            loop={false}
            navigation={false}
            modules={[Navigation]}
            slidesPerView={"auto"}
            spaceBetween={30}
            allowTouchMove={false}
            breakpoints={{
              1200: {
                slidesPerView: 1.5,
              },
              1024: {
                slidesPerView: 1.3,
              },
              994: {
                slidesPerView: 1.1,
              },
              576: {
                slidesPerView: 1,
              },
              0: {
                slidesPerView: 1,
              },
            }}
          >
            {[1, 2, 3].map((index) => (
              <SwiperSlide className={styles.heroSwiperSlide} key={index}>
                <div className={styles.skeletonCard}>
                  <div className={styles.skeletonImage}></div>
                  <div className={styles.skeletonDiscount}></div>
                  <div className={styles.skeletonCardBottom}>
                    <div className={styles.skeletonTitle}></div>
                    <div className={styles.skeletonDescription}></div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    );
  }

  return (
    <section id={styles.hero_section}>
      <div className="container">
        <Swiper
          className={styles.heroSwiper}
          rewind={true}
          loop
          navigation={true}
          modules={[Navigation, Autoplay]}
          slidesPerView={"auto"}
          spaceBetween={30}
          allowTouchMove={true}
          autoplay={{
            delay: 7000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            1200: {
              slidesPerView: 1.5,
            },
            1024: {
              slidesPerView: 1.3,
            },
            994: {
              slidesPerView: 1.1,
            },
            576: {
              slidesPerView: 1,
            },
            0: {
              slidesPerView: 1,
            },
          }}
        >
          {cardData.length > 0 ? (
            cardData.map((card, index) => (
              <SwiperSlide className={styles.heroSwiperSlide} key={index}>
                <Link to={`/campaigns/${card.id}`}>
                  <div className={styles.card}>
                    {/* <div className={styles.cardDate}>{card.start_date}</div> */}
                    <div className={styles.img}>
                      <img
                        src={getCardImage(card, selectedLanguage)}
                        alt={card.name || "hero"}

                        loading={index === 0 ? "eager" : "lazy"}
                        // @ts-ignore
                        fetchpriority={index === 0 ? "high" : "auto"}
                      />
                    </div>
                    {card.discount > 0 ? (
                      <div className={styles.cardDiscount}>
                        <p className={styles.discount}>{card.discount}</p>
                      </div>
                    ) : null}
                    <div className={styles.cardBottom}>
                      <p className={styles.cardBottomTitle}>{card.name}</p>
                      {card.description && (
                        <p className={styles.cardBottomText}>
                          {card.description}
                        </p>
                      )}
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))
          ) : (
            <div className={styles.loading}>Yüklənir...</div>
          )}
        </Swiper>
      </div>
    </section>
  );
};

export default HeroSection;
